import React, {useEffect, useMemo, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {validationChecker} from "../../../components/commonmethod/CommonMethod";
import {PageHeader} from "../../../components/PageHeader";
import Th_title from "../../../components/Th_title";
import InputBasic from "../../../components/input/InputBasic";
import TextAreaBasic from "../../../components/input/TextAreaBasic";
import {handleActiveError, handleActiveToast} from "../../../components/sonner/ToastBasic";
import {
    ContentDetailTwoColLayout,
    DetailFilePanel,
    DetailKvReadOnly,
    DetailKvTable,
    DetailListPage,
    DetailPanel,
    DetailSummaryButton,
    DetailSummaryListButton,
} from "../../../components/detailLayout";
import "../../../components/detailLayout/detailListLayout.css";
import "../fieldMng/shared/codeManageSettings.css";
import {SettingsContentHeroActions} from "./SettingsContentHeroActions";

function ContentRegisterForm({gubun, pageHeader, cancelPath, onSubmit, successPath}) {
    const navigate = useNavigate();
    const user = useSelector((state) => state.auth.user);
    const [data, setData] = useState({gubun, subject: "", content: ""});
    const [docs, setDocs] = useState([]);

    const registeredAt = useMemo(() => {
        const now = new Date();
        return now.toLocaleString("ko-KR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        });
    }, []);

    const handleCreate = async () => {
        if (!validationChecker(data)) {
            return;
        }

        const docFiles = docs.map((each) => each.object);
        const response = await onSubmit(data, docFiles);

        if (response?.status === 200) {
            handleActiveToast({message: "등록되었습니다."});
            navigate(successPath(response.data.id), {state: {id: response.data.id}});
            return;
        }

        handleActiveError({message: "등록에 실패했습니다."});
    };

    const headerActions = (
        <SettingsContentHeroActions>
            <DetailSummaryListButton url={cancelPath}>취소</DetailSummaryListButton>
            <DetailSummaryButton onClick={handleCreate}>등록</DetailSummaryButton>
        </SettingsContentHeroActions>
    );

    const renderedPageHeader = React.isValidElement(pageHeader)
        ? React.cloneElement(pageHeader, {headerActions})
        : pageHeader;

    const mainPanel = (
        <DetailPanel title="기본정보">
            <DetailKvTable>
                <tbody>
                <tr>
                    <DetailKvReadOnly label="등록일시" value={registeredAt}/>
                    <DetailKvReadOnly label="수정일시" value=""/>
                </tr>
                <tr>
                    <DetailKvReadOnly label="등록자" value={user?.name ?? ""}/>
                    <DetailKvReadOnly label="수정자" value=""/>
                </tr>
                <tr>
                    <Th_title title="제목" colspan={3} className="fieldset-td" required={true}>
                        <InputBasic target="subject" data={{data, setData}}/>
                    </Th_title>
                </tr>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title="내용" colspan={3} className="fieldset-td">
                        <TextAreaBasic target="content" data={{data, setData}}/>
                    </Th_title>
                </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );

    const filePanel = (
        <DetailFilePanel
            title="파일"
            isEditing
            pendingFiles={{files: docs, setFiles: setDocs}}
            pendingInputId={`content_register_doc_${gubun}`}
        />
    );

    return (
        <div className="common-container container-height-full border-l-gray detail-list-layout asset-detail-list-layout flex min-h-0 flex-1 flex-col code-manage-scope">
            {renderedPageHeader}

            <DetailListPage isEditing className="flex min-h-0 flex-1 flex-col">
                <div className="container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col overflow-hidden">
                    <ContentDetailTwoColLayout main={mainPanel} aside={filePanel}/>
                </div>
            </DetailListPage>
        </div>
    );
}

export default ContentRegisterForm;
